import {Component, Inject, LOCALE_ID} from '@angular/core';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
	public readonly language: string;
	constructor(@Inject(LOCALE_ID) private locale: string) {
		this.language = locale.substring(0, 2).toLowerCase();
	}

	currentYear(): number {
		return new Date().getFullYear();
	}
}
